import type { ComponentType, ReactNode } from 'react'

import { Card } from '@/shared/ui/Card'

interface BlockEmptyStateProps {
  icon?: ComponentType<any>
  title: string
  /** O que o participante pode fazer para o bloco deixar de estar vazio. */
  hint: string
  /**
   * Ação opcional — na prática, a porta da orientação (`GuidanceDoor`).
   *
   * Renderiza como **rodapé do card**, fora do `Card.Body`: dentro dele o
   * `px-4` recuaria a borda superior e ela deixaria de ler como rodapé. Abaixo
   * do texto e nunca ao lado — MASTER §7 L2 admite um elemento fixo ao lado de
   * uma linha de texto, e o ícone já ocupa essa vaga.
   */
  action?: ReactNode
}

/**
 * Estado vazio dos blocos de sistema com `emptyPolicy: placeholder`.
 *
 * Antes desta change o bloco simplesmente sumia — `MedalsPreview` fazia
 * `if (isLoading || isEmpty) return null`. O produtor posicionava o bloco no
 * editor, não via nada na home e não entendia o motivo.
 *
 * A tela explicativa de "como conquistar", acionada pelo clique, é change
 * própria de UX/UI e não faz parte desta.
 */
export const BlockEmptyState = ({
  icon: Icon,
  title,
  hint,
  action
}: BlockEmptyStateProps) => (
  <Card className="card-gamification">
    <Card.Body className="flex flex-col px-4 py-4">
      <div className="flex items-center gap-3">
        {Icon && (
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[color-mix(in_srgb,var(--color-brand)_10%,white)]">
            <Icon
              size={20}
              variant="duotone"
              className="text-[var(--color-brand)]"
              aria-hidden
            />
          </span>
        )}
        <div className="flex min-w-0 flex-col gap-0.5">
          <p className="m-0 text-sm font-bold leading-snug text-gray-900">
            {title}
          </p>
          <p className="m-0 text-xs leading-snug text-gray-700">{hint}</p>
        </div>
      </div>
    </Card.Body>

    {action}
  </Card>
)
